import styled from 'styled-components';

export const Chart = styled.div<{ isHidden: boolean }>`
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  ${({ isHidden }) => isHidden && `visibility: hidden`};
`;
